import {IServiceFactoryExtended} from "../../../service-factory-extended.interface";
import {makeObservable, observable} from "mobx";
import {
    AB_TESTING_DATA_FOR_AUTHORIZED_USER_STORAGE_KEY
} from "../../ab-testing-local-storage-keys";
import {AbTestingBaseStrategy} from "../ab-testing-base.strategy";
import {IAbTestingData, IAbTestingFeature} from "../../ab-testing-feature-data-provider.service.interface";




export class AbTestingForAuthorizedUserStrategy extends AbTestingBaseStrategy {
    constructor(services: IServiceFactoryExtended) {
        super(services);

        this._testData = this._readTestData();
        this.services.localStorage.setJson(AB_TESTING_DATA_FOR_AUTHORIZED_USER_STORAGE_KEY, this._testData);
        if(this._testData.AnonymousPlayerId) {
            this.anonymousPlayerId = this._testData.AnonymousPlayerId;
        }

        makeObservable(this);
    }

    @observable.ref
    private readonly _testData: IAbTestingData;

    getFeature(featureName: string): IAbTestingFeature | null {
        return this._findFeature(featureName, this._testData);
    }

    waitForLoadTestData(): Promise<void> {
        return Promise.resolve();
    }

    private _readTestData(): IAbTestingData {
        const testDataJson = this.services.sdk.extractTokenProperty('abTestingData');
        if(testDataJson) {
            return this._parseTestDataJson(testDataJson);
        } else {
            return this._readAuthorizedTestDataFromLocalStorage();
        }
    }

    private _parseTestDataJson(json: string): IAbTestingData {
        try {
            const testData: IAbTestingData = JSON.parse(json);

            if(testData.ErrorDescription) {
                this.services.logger.error('Error received from A/B testing service', testData.ErrorDescription);
            }
            return {
                ErrorDescription: testData.ErrorDescription,
                AnonymousPlayerId: testData.AnonymousPlayerId,
                Features: testData.Features ?? {}
            };

        } catch (err) {
            this.services.logger.error('Failed to parse A/B testing data', err, json);
            return this._readAuthorizedTestDataFromLocalStorage();
        }
    }

}